<template>
  <div class="dados-pessoais-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Nome_Completo')"
            :value="pessoa.nome | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('nome')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Email')"
            :value="pessoa.email"
            :is-restrict="$store.getters['pessoa/isRestrict']('email')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Genero')"
            :value="pessoa.genero"
            :is-restrict="$store.getters['pessoa/isRestrict']('genero')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Data_Nasc')"
            :value="pessoa.dataNasc"
            :is-restrict="$store.getters['pessoa/isRestrict']('dataNasc')"
          >
            <template #value>
              {{ pessoa.dataNasc | toLocaleDate }}
            </template>
          </field-section>
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('CEP')"
            :value="pessoa.cep"
            :is-restrict="$store.getters['pessoa/isRestrict']('cep')"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Contato_Emergencia')">
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Nome_Contato')"
            :value="pessoa.nomeContato | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('nomeContato')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Email_Contato')"
            :value="pessoa.emailContato"
            :is-restrict="$store.getters['pessoa/isRestrict']('emailContato')"
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Telefone_1')"
            :value="pessoa.fone1Contato"
            :is-restrict="$store.getters['pessoa/isRestrict']('fone1Contato')"
          />
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('Telefone_2')"
            :value="pessoa.fone2Contato"
            :is-restrict="$store.getters['pessoa/isRestrict']('fone2Contato')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pessoa" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Pessoais") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Pessoais"),
  }),
  computed: {
    pessoa() {
      return this.$store.state.pessoa.data || {};
    },
  },
};
</script>

<style scoped></style>
